'use client';

import { Check } from "@phosphor-icons/react";
import classNames from "classnames";
import { Plans } from "@/constants/prices";

const Pill = ({ color = "black", text = "" }) => {
    return (
        <div className={classNames({
            "px-2.5 py-1 text-white text-[13px] font-bold": true,
            "rounded-[300px] inline-flex justify-center items-center gap-2.5": true,
            "bg-gradient-porange": color === "porange",
            "bg-gradient-to-l from-[#1a1f58] to-[#500f56]": color === "purple",
            "bg-black": color === "black",
            "bg-[#18c1ae]": color === "green",
        })}>
            {text}
        </div>
    )
}

export const SubscriptionPlanOption = ({
    isSelected = false,
    plan = Plans.YEAR,
    onPlanSelect,
    pricePerMonth,
    priceAmount,
    strikedOutPrice
}) => {
    const savePercentage = Math.round(((strikedOutPrice - pricePerMonth) / strikedOutPrice) * 100 / 10) * 10;
    return (
        <div
            onClick={onPlanSelect}
            className={classNames("px-4  rounded-xl  flex-col box-content", {
                "bg-white shadow-lg text-blue-950": isSelected,
                "bg-[#0c1622]/20 border border-gray-200 text-white": !isSelected,
                "gap-2 relative": true,
                "flex justify-center py-3 h-16": plan === Plans.MONTH,
                "pt-6 pb-3 h-fit": plan === Plans.YEAR,
            })}>
            {isSelected &&
                <div className="absolute top-0 left-4 -translate-y-1/2 space-x-1">
                    {plan === Plans.YEAR && <Pill color="purple" text={`Save ${savePercentage}%`} />}
                    <Pill color="green" text="7-DAY FREE TRIAL" />
                </div>}

            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <div className={classNames("size-8 rounded-full flex items-center justify-center", {
                        "bg-gradient-porange": isSelected,
                        "border-2 border-white": !isSelected,
                        "mb-2": plan === Plans.YEAR,
                    })}>
                        {isSelected && <Check size={16} weight="bold" color="white" />}
                    </div>
                    <span className="text-lg font-semibold">
                        {plan === Plans.YEAR ? "Annual" : "1 Month"}
                    </span>
                </div>
                <span className="text-lg font-medium">${pricePerMonth.toFixed(2)}/mo</span>
            </div>
            {plan === Plans.YEAR &&
                <div className="flex items-center justify-between text-[#8e9cad] text-[11px] font-normal">
                    <div>
                        <span className="">${priceAmount.toFixed(2)} billed {plan === Plans.YEAR ? "annually" : "monthly"}</span>
                    </div>
                    <span className="line-through">${strikedOutPrice.toFixed(2)}/mo</span>
                </div>}
        </div>
    );
}